import type { BaremetalServer } from '@/entities/baremetal';
import request from '@/shared/api/request';

export const powerOnBaremetalServer = (id: number): Promise<{ baremetal: BaremetalServer }> =>
  request({
    url: `/baremetals/${id}/`,
    method: 'POST',
    data: { action: 'power_on' },
  });
